import React from 'react';
import SearchReport, { ISearchReportProps } from './SearchReport';
import { PageLoading } from 'ui-toolkit';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { ErrorMessageTW } from '../../tailwindComponents/errorMessage/ErrorMessageTW';
import { useGetUserType } from 'components/accessControl/hooks/useGetUserType';
import { eAccessControlUserType } from '../../ui-toolkit/enums/eAccessControlUserType';
import { inject } from 'mobx-react';
import { RootStore } from '../services/RootStore';

interface ISearchReportPageProps {
  rootStore?: RootStore;
}

const AdminSearchReportPageContent: React.FC<ISearchReportProps & ISearchReportPageProps> = (props) => {
  const userType = useGetUserType();
  const { data, fetchError, fetchStatus } = useSelectCurrentOrder();

  if (!props.rootStore) return <PageLoading isLoading />;

  return (
    <>
      <PageLoading isLoading={fetchStatus.fetching} />
      <ErrorMessageTW error={fetchError} />
      <SearchReport {...props} order={data} userType={userType} rootStore={props.rootStore} />
    </>
  );
};

const SearchReportPageContent: React.FC<ISearchReportProps & ISearchReportPageProps> = (props) => {
  const userType = useGetUserType();

  if (!props.rootStore) return <PageLoading isLoading />;

  return (
    <>
      {userType === eAccessControlUserType.Admin ? (
        <AdminSearchReportPageContent {...props} />
      ) : (
        <SearchReport {...props} userType={userType} rootStore={props.rootStore} />
      )}
    </>
  );
};

export const SearchReportPage = inject('rootStore')((props: ISearchReportProps & ISearchReportPageProps) => {
  return <SearchReportPageContent {...props} />;
});
